import { useFetch } from '../useFetch'
import { BUDGET_URL } from './constants'

export type UpdateBudgetLinkedEntityParams = {
  budgetId: string
  allocationId: string
  linkedEntityId: string
}

export function useBudgetEntity() {
  const { fetcherWrapper } = useFetch()

  const updateLinkedEntity = async (
    params: UpdateBudgetLinkedEntityParams
  ): Promise<Response> => {
    const { budgetId, allocationId, linkedEntityId } = params

    const url = new URL(
      `${BUDGET_URL}/${budgetId}/allocation/${allocationId}/linked-entity`,
      window.location.origin
    )

    return fetcherWrapper(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(linkedEntityId),
    })
  }

  return { updateLinkedEntity }
}
